import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app/shared.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export interface IContenedor {
    id: string;
    TipoContenedor: string;
    PesoContenedorVacio: string;
    PesoNetoMercancia: string;
}

@Component({
    selector: 'app-carro',
    templateUrl: './carro.component.html',
    styleUrls: ['./carro.component.scss']
})
export class CarroComponent implements OnInit {
    @Input() id: any;
    @Input() carros: any;

    FormCarro: FormGroup;
    FormContenedor: FormGroup;
    submitted = false;

    countContenedor: any = [];
    removeDisabledContenedor: boolean = true;

    lstContenedor: IContenedor[] = []

    opcionesTipoCarro: Observable<any[]>;
    lstTipoCarro: any;
    
    constructor(
        private formBuilder: FormBuilder,
        private sharedService: SharedService,
        private srvcoal: CoalService,
    ) { }

    ngOnInit(): void {
        this.GetCarros()
        this.FormCarro = this.formBuilder.group({
            id: [''],
            TipoCarro: ['', Validators.required],
            MatriculaCarro: ['', Validators.required],
            GuiaCarro: ['', Validators.required],
            ToneladasNetasCarro: ['', Validators.required],
            Contenedor: []
        });

        console.log("Validacion Carro Init : ", this.FormCarro.value);

        this.FormCarro.controls.id.setValue(this.id.id)
        this.FormCarro.valueChanges.subscribe(changes => {
            if (this.FormCarro.valid) {
                console.log("Validacion Carro : ", this.FormCarro.value);
                this.sharedService.setFormFerroviariosCarro(changes);
            }
        });

        this.sharedService.ferroCarroContenedorForm$.subscribe(valores => {
            const index = this.lstContenedor.findIndex(item => item && item.id === valores.id);
            if (index === -1) {
                if (valores) {
                    if (valores.id.includes(this.id.id)) {
                        if (valores) this.lstContenedor.push(valores);
                    }
                }
            } else {
                if (valores) this.lstContenedor[index] = valores;
            }
            this.FormCarro.controls.Contenedor.setValue(this.lstContenedor);
        });

       
    }

    asignarContenedor(data) {

        this.countContenedor = [];
        if (data) {
            let datos = {
                TipoContenedor: data.attributes.cat_tipo_contenedor.data.id,
                PesoContenedorVacio: data.attributes.pesoContenedorVacio,
                PesoNetoMercancia: data.attributes.pesoNetoMercancia
            }
            this.countContenedor.push({ id: `Contenedor 1`, data: datos });
        }
    }

    //Agregar formulario
    addContenedor = () => {
        this.countContenedor.push({ id: `${this.id.id}Contenedor${this.countContenedor.length + 1}` });
        this.countContenedor.length <= 0 ? this.removeDisabledContenedor = true : this.removeDisabledContenedor = false;
    };

    //Remover formulario
    removeContenedor = () => {
        localStorage.removeItem(this.id.id + 'Contenedor' + this.countContenedor.length);
        this.countContenedor.splice(-1);
        this.countContenedor.length <= 0 ? this.removeDisabledContenedor = true : this.removeDisabledContenedor = false;
    };


    GetCarros() {
        this.srvcoal.getService(`cat-tipo-carros`,).subscribe((res: any) => {
            if (res.err) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.lstTipoCarro = res.data;
                if (this.carros) {
                    console.log(this.lstTipoCarro)
                    this.FormCarro.patchValue({
                        TipoCarro: this.carros.TipoCarro,
                        MatriculaCarro: this.carros.MatriculaCarro,
                        GuiaCarro: this.carros.GuiaCarro,
                        ToneladasNetasCarro: this.carros.GuiaCarro
                    });
                    this.asignarContenedor(this.carros.Contenedor)
                }
                this.opcionesTipoCarro = this.FormCarro.get('TipoCarro').valueChanges.pipe(
                    startWith(''),
                    map(state => (state ? this._filtrarTipoCarro(state) : this.lstTipoCarro)),
                );


            }
            // this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            // this.store.dispatch(OcultarSpinner())
        });
    }

    displayTipoCarro = (bienes: any): string => {
        const servicioEncontrado = this.lstTipoCarro.find((f: any) => f.id === bienes);
        if (servicioEncontrado) {
            return `${servicioEncontrado.attributes.clave} - ${servicioEncontrado.attributes.tipoCarro}`;
        } else {
            return '';
        }
    }

    private _filtrarTipoCarro(value: any): any[] {
        const filterValue = value?.toLowerCase();

        return this.lstTipoCarro.filter(unidad =>
        (unidad.attributes.clave.toLowerCase().includes(filterValue) ||
            unidad.attributes.tipoCarro.toLowerCase().includes(filterValue))
        );
    }

}
